/**
 * questionnaireMode.js
 * SC-M8-01: Standalone module for questionnaire mode flag.
 * Prevents 401 interceptor from expelling user during active questionnaire.
 */
let _isInQuestionnaire = false;

export const setQuestionnaireMode = (active) => {
  _isInQuestionnaire = active;
};

export const isInQuestionnaireMode = () => _isInQuestionnaire;
